import { render, staticRenderFns } from "./SubmittedWord.vue?vue&type=template&id=b932440a&scoped=true&"
import script from "./SubmittedWord.vue?vue&type=script&lang=js&"
export * from "./SubmittedWord.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedWord.vue?vue&type=style&index=0&id=b932440a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b932440a",
  null
  
)

export default component.exports